// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e64aabd6","977":"7e5da1c7"}[chunkId] + ".chunk.js";
};